import * as React from 'react';
import { MVK, NewbuildingMvkContext } from '@cian/frontend-newbuilding-mvk-widget';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenFloorPlan } from '../../actions/floorPlan';
import { FloorPlanHeader } from '../../components/FloorPlanHeader';
import { getHouseId, isFloorPlanOpened } from '../../selectors/floorPlan';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/withApplicationContext';

export const FloorPlan = () => {
  const dispatch = useDispatch();

  const { httpApi, logger } = useApplicationContext();
  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const isOpened = useSelector(isFloorPlanOpened);
  const newbuildingId = useSelector(getNewbuildingId);
  const houseId = useSelector(getHouseId);

  const onClose = () => {
    dispatch(setOpenFloorPlan(false));
  };

  if (!isOpened) {
    return null;
  }

  return (
    <ModalFullscreen escape open print theme="white" onClose={onClose}>
      <FloorPlanHeader onClose={onClose} />
      <NewbuildingMvkContext.Provider value={contextValue}>
        <MVK newbuildingId={newbuildingId} houseId={houseId} sectionId={null} pageTypeJK="Featuring" />
      </NewbuildingMvkContext.Provider>
    </ModalFullscreen>
  );
};

// eslint-disable-next-line import/no-default-export
export default FloorPlan;
